import { DecoratorNode, $applyNodeReplacement } from 'lexical';
import { markRaw } from 'vue';
import EditorSeparator from '../Components/EditorSeparator.vue';
import { blockRhythm, separator } from '../Themes/EditorClasses';

export class HorizontalRuleNode extends DecoratorNode {
    static getType() {
        return 'horizontalrule';
    }

    static clone(node) {
        return new HorizontalRuleNode(node.__key);
    }

    static importJSON() {
        return $createHorizontalRuleNode();
    }

    static importDOM() {
        return {
            hr: () => ({ conversion: () => ({ node: $createHorizontalRuleNode() }), priority: 0 }),
        };
    }

    exportJSON() {
        return { type: 'horizontalrule', version: 1 };
    }

    // Public render is a clean semantic <hr>; the editor frame + hosted handle live only in decorate().
    exportDOM() {
        const element = document.createElement('hr');
        element.className = `${blockRhythm} ${separator}`;
        return { element };
    }

    getTextContent() {
        return '\n';
    }

    isInline() {
        return false;
    }

    createDOM() {
        return document.createElement('div');
    }

    updateDOM() {
        return false;
    }

    decorate(editor) {
        return {
            component: markRaw(EditorSeparator),
            props: {
                editable: editor.isEditable(),
            },
        };
    }
}

export function $createHorizontalRuleNode() {
    return $applyNodeReplacement(new HorizontalRuleNode());
}

export function $isHorizontalRuleNode(node) {
    return node instanceof HorizontalRuleNode;
}
